import * as React from 'react'
import PropTypes from 'prop-types'

import {
  DASHBOARD_URL,
  INBOX_URL,
  ARTIST_PROFILES_URL,
  HELP_URL,
} from '../../../models/Controlpanel'
import { getLogoutUrl } from '../../../models/Auth'

import { MobileMenu, ButtonInnerContent, RequestsUnreadCountWrapper } from './style'
import { shutdownIntercom } from './util'

import HeaderMenuMobileWrapper from '../../../components/header-menu-mobile-wrapper'
import HeaderMenuList from '../../../ui/header-menu-list'
import HeaderMenuItem from '../../../ui/header-menu-list-item'
import HeaderMenuButton from '../../../ui/header-menu-button'
import { SearchIcon } from '../../../icons'
import HeaderMenuSpacer from '../../../ui/header-menu-list-item-spacer'

import HeaderMenuItemUserMobile from '../../header-menu-item-user-mobile'
import GigRequestUnreadCount from '../../gig-request-unread-count'

const EventplannerMobileMenu = ({ eventplannerRequestCount }) => (
  <MobileMenu>
    <HeaderMenuMobileWrapper forArtist>
      <HeaderMenuList inDropdown>
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton inDropdown to="/">
            Hjem
          </HeaderMenuButton>
        </HeaderMenuItem>
        <HeaderMenuItemUserMobile />
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton
            inDropdown
            to={DASHBOARD_URL}
            title="Gå til søk"
            aria-label="Gå til søk"
          >
            Kontrollpanel
          </HeaderMenuButton>
        </HeaderMenuItem>
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton inDropdown to={INBOX_URL}>
            <ButtonInnerContent>
              Forespørsler
              <RequestsUnreadCountWrapper inDropdown>
                <GigRequestUnreadCount forArtist />
              </RequestsUnreadCountWrapper>
            </ButtonInnerContent>
          </HeaderMenuButton>
        </HeaderMenuItem>
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton
            inDropdown
            to={ARTIST_PROFILES_URL}
            title="Gå til artist-profiler"
            aria-label="Gå til artist-profiler"
          >
            Artist-profiler
          </HeaderMenuButton>
        </HeaderMenuItem>
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton to={HELP_URL} title="Gå til hjelp" aria-label="Gå til hjelp" inDropdown>
            Hjelp
          </HeaderMenuButton>
        </HeaderMenuItem>
        {eventplannerRequestCount > 0 ? (
          <HeaderMenuItem inDropdown>
            <HeaderMenuButton inDropdown to="/eventplanner">
              Bytt til arrangør
            </HeaderMenuButton>
          </HeaderMenuItem>
        ) : null}
        <HeaderMenuSpacer />
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton
            inDropdown
            onClick={shutdownIntercom}
            href={getLogoutUrl()}
            title="Logg ut"
            aria-label="Logg ut"
          >
            Logg ut
          </HeaderMenuButton>
        </HeaderMenuItem>
      </HeaderMenuList>
    </HeaderMenuMobileWrapper>
  </MobileMenu>
)

EventplannerMobileMenu.propTypes = {
  eventplannerRequestCount: PropTypes.number.isRequired,
}
EventplannerMobileMenu.defaultProps = {}

export default EventplannerMobileMenu
